module.exports = __webpack_public_path__ + "img/Group 1-1.d8a7e3a9.svg";